<section class="content">
  <app-breadcrumbs type="compareProfiles"></app-breadcrumbs>
  <div class="card">
    <div class="card-body">
      <app-compare-generate></app-compare-generate>
    </div>
  </div>
  <app-compare-result></app-compare-result>
</section>

